export default "__VITE_ASSET__5bCPAqrt__"